var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5078 3.12862C21.2543 2.94769 20.9392 2.87479 20.632 2.92593C20.3247 2.97707 20.0503 3.14806 19.869 3.40137L9.32108 18.1663C9.27147 18.2357 9.20734 18.2935 9.13315 18.3356C9.05897 18.3777 8.9765 18.4032 8.89149 18.4102C8.80647 18.4173 8.72094 18.4057 8.64083 18.3764C8.56073 18.3471 8.48796 18.3006 8.42759 18.2404L4.02127 13.8341C3.91282 13.7218 3.7831 13.6322 3.63966 13.5706C3.49623 13.509 3.34196 13.4765 3.18586 13.4752C3.02976 13.4738 2.87495 13.5036 2.73047 13.5627C2.58599 13.6218 2.45472 13.7091 2.34434 13.8195C2.23395 13.9299 2.14666 14.0611 2.08755 14.2056C2.02843 14.3501 1.99869 14.5049 2.00004 14.661C2.0014 14.8171 2.03383 14.9714 2.09545 15.1148C2.15706 15.2582 2.24662 15.388 2.35891 15.4964L7.25548 20.393C7.69546 20.8331 8.29198 21.0808 8.91431 21.0819C8.97897 21.0819 9.04481 21.0819 9.10947 21.0737C9.45056 21.0468 9.7816 20.9454 10.0792 20.7766C10.3768 20.6078 10.6337 20.3757 10.8318 20.0967L21.7818 4.76747C21.9626 4.51375 22.0353 4.19865 21.9839 3.89136C21.9326 3.58408 21.7613 3.30974 21.5078 3.12862Z",
    fill: "#DCDEE2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.b262d025e6c861d33fd98f5e3d90b06e.svg";
export { ForwardRef as ReactComponent };